import React from 'react';

import { rest } from '@app/components/Api';
import {
	angelBlockRichTitle,
	angelFundFiftyText,
	angelFundFiftyTitle,
	mastheadText,
} from '@app/components/Pages/AngelFund/angelFundContent';
import FiftyFifty from '@app/components/UI/FiftyFifty/FiftyFifty';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import BlockRich from '@app/components/UI/LinkBlock/BlockRich';
import Masthead from '@app/components/UI/MastHead/Masthead';
import angelFund from '@app/images/content/angel_fund.png';
import angelFundMobile from '@app/images/content/mobile/angel_fund.png';
import angelFundFifty from '@app/images/content/angel_fund_fifty.png';
import img3 from '@app/images/content/Dr.Dani.png';
import img1 from '@app/images/content/Dr.Rachel.jpg';
import img2 from '@app/images/content/Yvonne and Ranger.jpg';
import '@app/scss/components/angelFund.scss';

interface AngelFundContent {
	header: string;
	smallHeader: string;
	block1Text: string;
	block2Text: string;
}

const AngelFund: React.FC = () => {
	const [content, setContent] = React.useState<AngelFundContent>({
		header: 'Angel Fund',
		smallHeader: mastheadText,
		block1Text: angelFundFiftyText,
		// eslint-disable-next-line max-len
		block2Text: "One of the amazing aspects of the human-animal bond is the fact that it never seems to go away. No matter how long it been since a beloved pet has passed, we remember them, their quirks, and their cuteness like it was yesterday. So when you donate to the Angel Fund to help families and their pets, you're not just donating to support a single passing moment in time—you're donating to an experience that will stay in people’s hearts and minds forever, a moment of immeasurable importance with an impact they’ll feel for the rest of their lives.",
	});

	const url = 'https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=X9CSF2LY7DG84';

	React.useEffect(() => {
		rest.get<AngelFundContent>('v1/content/angel fund').then((res) => res && setContent(res));
	}, []);

	return (
		<HelmetProvider>
			<div className="angel-fund">
				<Masthead
					title={content.header}
					imageSrc={angelFund}
					mobileSrc={angelFundMobile}
					text={content.smallHeader}
					buttonText={(
						<a href={url} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
							Donate today
						</a>
					)}
					imageAlt="Angel fund"
					other={
						<div className="angel-fund__other">
							* All donations to Lap of Love’s Angel Fund go toward families and pets in need; however, donations are not tax deductible.
						</div>
					}
				/>
				<FiftyFifty
					title={angelFundFiftyTitle}
					text={
						<>
							<p>{content.block1Text}</p>
							<p style={{ fontStyle: 'italic' }}>
								*The Angel Fund is a limited resource only dispersed at Lap of Love's discretion depending on the severity of the need.
							</p>
						</>
					}
					src={angelFundFifty}
					reversed
					alt="Lap of Love donation"
					extraBlock={(
						<div className="fifty-fifty__btn">
							<a href={url} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
								Become an angel
							</a>
						</div>
					)}
				/>

				<BlockRich
					title={angelBlockRichTitle}
					text={content.block2Text}
					images={[
						{ title: 'Dr. Rachel', src: img1, alt: 'Lap of Love Veterinary Hospice' },
						{ title: 'Dr. Dani', src: img3, alt: 'Pet Loss Support Group' },
						{ title: 'Yvonne and Ranger', src: img2, alt: 'End of life geriatric pet' },
					]}
					buttonCaption="Make an impact"
					link={url}
				/>
			</div>
		</HelmetProvider>
	);
};

export default AngelFund;
